import React, {useEffect} from "react";
import "./Exp.css";

import AOS from "aos";
import "aos/dist/aos.css";

function Exp() {


  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
      <div className="Exp" id="exp">
        <div className="head" data-aos={"fade-up"} >
          <div className="head-main">
            <h4>02.</h4>
            <h2>Where I've Worked</h2>
          </div>
        </div>

        <div className="exp-timeline" data-aos={"fade-up"} data-aos-delay="300">
          <ul class="timeline">
            <li>
              <div class="direction-r">
                <div class="flag-wrapper">
                  <span class="flag">Binary Bytes</span>
                </div>
                <div class="desc">
                  My current employment. Way better than the position before!
                </div>
              </div>
            </li>

            <li>
              <div class="direction-l">
                <div class="flag-wrapper">
                  <span class="flag">Freelancer</span>
                </div>

                <div class="desc">
                  My first employer. All the stuff I've learned and projects
                  I've been working on.
                </div>
              </div>
            </li>

            <li>
              <div class="direction-r">
                <div class="flag-wrapper">
                  <span class="flag">Spectrum</span>
                </div>
                <div class="desc">
                  A description of all the lectures and courses I have taken and
                  my final degree?
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
  );
}

export default Exp;
